import { Issue, useCurrentAccount, useFindByQuery } from '@gripp/shared-logic';
import { useMemo } from 'react';
import LoadingIndicator from '../loadingIndicator';
import { ReminderSummary } from './reminderSummary';

/**
 * Reminder strip rendered under the Activity header. Shared by both header
 * variants (classic and the Communication Platform bar) so the workflow lookup
 * is defined once.
 */
export const IssueHeaderReminder = ({ issue }: { issue: Issue }) => {
  const { account } = useCurrentAccount();
  const isRestrictedUser =
    account?.effectivePermissions?.includes('*.restricted');

  const issueId = issue.id;

  const filter = useMemo(() => {
    return {
      trigger: {
        type: {
          eq: 'ISSUE',
        },
      },
      and: [
        {
          disabled: {
            ne: true,
          },
        },
      ],
      json: { 'trigger.config.issueId': issueId },
    };
  }, [issueId]);

  const { data: workflows, isLoading } = useFindByQuery({
    modelName: 'workflow',
    query: FIND_WORKFLOWS,
    variables: { filter },
  });

  const workflow = useMemo(() => workflows?.items[0], [workflows]);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (isRestrictedUser || !workflow) {
    return null;
  }

  return <ReminderSummary workflow={workflow} issue={issue} />;
};

const FIND_WORKFLOWS = `
  query FindWorkflows($filter: WorkflowFilter) {
    findWorkflows(filter: $filter) {
      count
      items {
        id
        name
        workspace {
          id
        }
        trigger {
          type
          config
        }
        action {
          type
          config
        }
      }
    }
  }
`;
